export default "__VITE_ASSET__jNgEl7NX__"